import SignDetail from './view';

export default SignDetail;


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/image_correction/image_correction_detail/sign_detail/index.js